import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class DeleteWorkbooksRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('deleteWorkbooks', { ids: ids });
  }
}
